import React from 'react';
import { BaseGym } from '../../types/Gym';
import { Calendar, Members, NoContract, Pass } from '../Icons';
import { Button } from '@husslehq/ui-library';

import styles from './DirectModal.module.scss';

export type DirectModalProps = {
  onCloseModal: () => void;
  onBuyProduct: (type: string, id: string, gym: BaseGym) => void;
  isTemporarilyClosed?: boolean;
  gym: BaseGym;
  productId: string;
};

export const DirectModal: React.FC<DirectModalProps> = ({
  onCloseModal,
  onBuyProduct,
  isTemporarilyClosed,
  gym,
  productId,
}) => {
  const directModalBullets = [
    {
      title: 'Access Now',
      desc: 'Choose, buy and access your gym with our instant code.',
      icon: <Pass />,
    },
    {
      title: 'Hassle Free',
      desc: 'Your gym will contact you to finalise your membership.',
      icon: <NoContract />,
    },
    {
      title: 'Success!',
      desc: 'You’re now a full member with access to the gym and facilities.',
      icon: <Members />,
    },
    {
      title: 'In Control',
      desc: 'Easily manage your membership and payments via Hussle.',
      icon: <Calendar />,
    },
  ];

  return (
    <div className={styles.modal}>
      <Button level="link" className={styles.modal__close} onClick={onCloseModal}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
          width="24px"
        >
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </Button>
      <h4 className={styles.modal__title}>How does a Gym Membership work?</h4>
      <ol className={styles.modal__list}>
        {directModalBullets.map((item, idx) => (
          <li key={`direct-modal__item-${idx}`} className={styles['modal__list-item']}>
            <div className={styles['modal__list-icon']}>{item.icon}</div>
            <h5 className={styles['modal__list-title']}>
              {idx + 1}. {item.title}
            </h5>
            <p className={styles['modal__list-desc']}>{item.desc}</p>
          </li>
        ))}
      </ol>
      <div className={styles.modal__actions}>
        <Button
          level="primary"
          size="large"
          disabled={isTemporarilyClosed}
          fullWidth
          className={styles.modal__button}
          onClick={() => onBuyProduct('direct', productId, gym)}
        >
          Get a Gym Membership
        </Button>
        <Button size="large" level="outline" fullWidth className={styles.modal__button} onClick={onCloseModal}>
          Back
        </Button>
      </div>
    </div>
  );
};
